import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { toastSamples } from '../fixtures/uiKitFixtures';

function toneClass(tone) {
  if (tone === 'success') return 'border-game-accent/40 bg-game-accent/15 text-game-accent';
  if (tone === 'reward') return 'border-game-popup/60 bg-game-popup/30 text-game-usermsg';
  return 'border-white/15 bg-game-surface text-game-text';
}

export default function GameNotificationsPreview() {
  const [shown, setShown] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setShown([]);
      for (let i = 0; i < toastSamples.length; i += 1) {
        await new Promise((r) => setTimeout(r, 450));
        if (cancelled) return;
        setShown((prev) => [...prev, toastSamples[i]]);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex min-h-[220px] flex-col gap-3 p-4">
      <div className="flex flex-col gap-2">
        <AnimatePresence initial={false}>
          {shown.map((toast, i) => (
            <motion.div
              key={`${toast.id}-${i}`}
              layout
              initial={{ opacity: 0, x: 28, scale: 0.94 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 16 }}
              transition={{ type: 'spring', damping: 20, stiffness: 320 }}
              className={`rounded-xl border px-3 py-2.5 text-xs font-medium shadow-md ${toneClass(toast.tone)}`}
            >
              {toast.message}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
